import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة زمن الوصول - حساب زمن الوصول بناءً على السرعة والمسافة";
const DESCRIPTION =
  "احسب زمن الوصول بدقة! حاسبة السرعة والمسافة توقّت وصولك بالدقائق والساعات - مثالية للرحلات، الشحن، الرياضة، أو أي جسم متحرك. أدخل المسافة والسرعة واحصل على النتيجة فوراً!";
const KEYWORDS = "زمن الوصول, حساب زمن الوصول, حاسبة الزمن";
const OG_URL = "https://do-calculate.com/calculator/ar/arrivaltime";
function Calculator() {
  const [distance, setDistance] = useState("");
  const [speed, setSpeed] = useState("");
  const [arrivalTime, setArrivalTime] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!distance || !speed) {
      setError("الرجاء إدخال المسافة والسرعة بشكل صحيح");
      setArrivalTime("");
      return;
    }
    const distanceValue = parseFloat(distance);
    const speedValue = parseFloat(speed);
    if (isNaN(distanceValue) || isNaN(speedValue) || speedValue <= 0) {
      setError("الرجاء إدخال قيم صحيحة وإيجابية للمسافة والسرعة");
      setArrivalTime("");
      return;
    }
    const arrivalTimeValue = distanceValue / speedValue;
    setArrivalTime(arrivalTimeValue.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  لحساب زمن الوصول، نحتاج إلى معرفة المسافة التي سيتم قطعها
                  والسرعة التي يتحرك بها الجسم.
                </p>
                <p>
                  يمكننا حساب زمن وصول شخص او شاحنة او سيارة او اى جسم متحرك عن
                  طريق ان نحدد سرعة هذا الجسم المتحرك سواء انسان او عربة او قطار
                  و حساب و معرفة المسافة التى سيتم قطعها هذا الجسم وعندما نحسب
                  السرعة التى يستطيع الجسم التحرك بها و المسافة المقطوعة يمكننا
                  حساب الزمن من الاتى:
                </p>
                <p>
                  <b>الزمن = المسافة المقطوعة/ سرعة الجسم</b>
                </p>
                <p>
                  ومن خلال معرفة الزمن الذى يستغرقه الجسم فى الوصول يمكننا معرفة
                  فى اى توقيت تحديدا سيصل الجسم للنقطة المطلوبة..
                </p>
                <p>
                  استخدم الحاسبة التالية لحساب زمن الوصول بناءً على السرعة
                  والمسافة
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          المسافة (كيلومتر)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          السرعة (كيلومتر/ساعة)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={speed}
                        onChange={(e) => setSpeed(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب زمن الوصول
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {arrivalTime !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              زمن الوصول (ساعة): {arrivalTime} ساعة
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              خطوات الحل: <br />- قم بحساب الزمن بالاستناد إلى
                              القانون التالي: الزمن (ساعة) = المسافة (كيلومتر) /
                              السرعة (كيلومتر/ساعة) - ثم قم بتقسيم المسافة التي
                              يجب قطعها على السرعة للوصول إلى الوقت النهائي.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
